import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgResearchingSm = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 25 25",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			id: "white",
			children: /* @__PURE__ */ _jsx("path", {
				className: "icon-white",
				d: "m10.97,6.95c-2.6,0-4.72,2.12-4.72,4.72s2.12,4.73,4.72,4.73,4.73-2.12,4.73-4.73-2.12-4.72-4.73-4.72Zm.45,5.69c-.19,0-.34-.16-.34-.34s.16-.34.34-.34.34.15.34.34-.15.34-.34.34Zm1.39-2.29c-.19,0-.34-.16-.34-.34s.15-.34.34-.34.34.16.34.34-.15.34-.34.34Zm2.49,1.04c-.19,0-.34-.16-.34-.34s.16-.34.34-.34.34.15.34.34-.15.34-.34.34Z"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "grey",
			children: /* @__PURE__ */ _jsx("path", {
				className: "icon-outline",
				d: "m17.23,17.39l-2.6-2.6.03-.03c.59-.71.97-1.56,1.08-2.48v-.12s-.1.03-.1.03c-.17.05-.35.07-.54.04h-.07s-.01.06-.01.06c-.3,1.98-2.04,3.47-4.04,3.47-2.25,0-4.09-1.83-4.09-4.09s1.83-4.09,4.09-4.09c1.57,0,3.02.92,3.7,2.35l.03.07.07-.03c.16-.08.34-.12.53-.12h.12l-.05-.1c-.77-1.75-2.49-2.87-4.4-2.87-2.65,0-4.8,2.15-4.8,4.8s2.15,4.8,4.8,4.8c1.12,0,2.22-.4,3.08-1.12l.03-.03,2.6,2.6c.07.07.17.11.27.11s.2-.04.27-.11c.07-.07.11-.17.11-.27s-.04-.2-.11-.27Z"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "color",
			children: /* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "m18.61,8.01c-.17-.16-.38-.25-.61-.25-.47,0-.85.38-.85.85,0,.11.02.21.06.3l-1.53,1.38c-.33-.17-.74-.1-1,.17l-1.02-.43v-.02c0-.48-.39-.86-.86-.86s-.85.38-.85.86c0,.18.07.36.18.51l-.57.95c-.05-.02-.1-.02-.15-.02-.47,0-.85.38-.85.85s.38.85.85.85.86-.38.86-.85c0-.19-.07-.37-.19-.52l.57-.94c.31.06.57-.04.77-.25l1.02.43v.03c0,.47.38.85.85.85s.85-.38.85-.85c0-.1-.02-.21-.06-.3l1.54-1.38c.12.06.25.09.38.09.47,0,.85-.38.85-.85,0-.23-.08-.44-.24-.6Zm-7.2,4.63c-.18,0-.34-.15-.34-.34s.16-.34.34-.34c.19,0,.35.15.35.34s-.16.34-.35.34Zm1.4-2.29c-.19,0-.35-.16-.35-.35,0-.18.16-.34.35-.34.18,0,.34.16.34.34,0,.19-.16.35-.34.35Zm2.48,1.04c-.19,0-.34-.15-.34-.34s.15-.34.34-.34.34.15.34.34-.15.34-.34.34Zm2.71-2.44c-.19,0-.34-.15-.34-.34s.15-.34.34-.34.34.15.34.34-.15.34-.34.34Z"
			})
		})
	]
});
export default SvgResearchingSm;
